import { render, staticRenderFns } from "./Study_cards.vue?vue&type=template&id=6a460395"
import script from "./Study_cards.vue?vue&type=script&lang=js"
export * from "./Study_cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports